import { styled } from "@mui/material/styles";

export const Header = styled("header")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",

  marginBottom: "1.75rem",
}));

export const HeaderTitle = styled("span")(() => ({
  color: "#465869",
  font: "700 20px/28px Manrope",
}));

export const HeaderBadges = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "0.75rem",
}));

export const VolumeBadge = styled("div")(() => ({
  height: 40,

  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "0.75rem",

  padding: "0.375rem 0.625rem", // 6px 10px
  backgroundColor: "#f8f9fc",
  borderRadius: "1.25rem",
  "& span": {
    color: "#465869",
    font: "500 12px/19.2px Manrope",
  },
  "& svg": {
    width: 16,
  },
}))
